<template>
  <div>
      <!-- 汇付银行卡签约 -->
  <div class="common-box border-t0">
    <el-row class="row-one">
      <span class="row-one-title">{{$route.params.name == "accountManagement"?'新增支付渠道':'安全验证'}}</span>
      <Reback class="row-one-fr" @click.native="reback"></Reback>
    </el-row>
    <el-form :model="verificationForm" :rules="verificationFormRules" ref="verificationFormRef" label-width="100px" label-position="right" class="form-single">
      <el-form-item label="银行卡：" class="margin-t50">
        <span class="form-single-sp">{{cardMessage.depositacct}}</span>
      </el-form-item>
      <el-form-item v-if="$route.params.name == 'accountManagement'" label="支付渠道：" class="margin-t-15">
        <span>{{bankActive.paycentername}}支付</span>
        <span :class="[{'aColor':channelFlag},'margin-l20']" style="cursor: pointer;" @click="replace">更换</span>
        <p class="form-single-tips">单笔{{bankActive.singledeallimit}}元，单日累计{{bankActive.singledaylimit}}元</p>
      </el-form-item>
      <el-form-item label="手机号：" prop="phone" :error="phoneError">
        <el-input v-model="verificationForm.phone" placeholder="预留手机号">
          <el-button :disabled="codeDisable" type="code" slot="append" @click="getCode">
            <span v-show="sendAuthCode">{{this.codefont == '0'? '获取验证码':'重新获取'}}</span>
            <span v-show="!sendAuthCode">{{auth_time}} 秒</span>
          </el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="验证码：" prop="code" :error="codeError">
        <el-input v-model="verificationForm.code" placeholder="请输入6位验证码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="normal" @click="submit">{{submitText}}</el-button>
      </el-form-item>
    </el-form>
    <section class="instruction margin-t70">
      <div class="instruction-li">
        <p class="instruction-li-title">温馨提示</p>
        <p class="instruction-li-con">为了您的资金安全，请输入银行预留手机号及验证码进行身份认证。</p>
      </div>
    </section>
  </div>
  <!-- 更换渠道 -->
  <el-dialog class="dialog-single-three" :visible.sync="dialogVisableChange" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
      <div class="dialog-single-three-p">支付渠道选择</div>
      <el-radio-group v-model="payType" class="radio-single-one margin-t20" @change="bankChange">
        <el-radio v-for="(item,i) in channelNot" :key="i" :label="item.paycentername">{{item.paycentername}}支付</el-radio>
      </el-radio-group>
      <p class="margin-t5" v-for="(val,ind) in channelNot" :key="ind">
        <span v-if="payType==val.paycentername">单笔{{val.singledeallimit}}元，单日累计{{val.singledaylimit}}元</span>
      </p>
      <div class="margin-t20">
        <el-button type="cancel" style="width:154px" @click="channelCancel">取消</el-button>
        <el-button type="normal1" @click="channelSure">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template> 

<script>
const Base64 = require("js-base64").Base64;
export default {
  data () {
    return {
      verificationForm: {
        phone: '',
        code: '',
      },
      verificationFormRules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
        ],
      },
      phoneError: '',
      codeError: '',
      // 验证码
      auth_time: 0,
      codeDisable: false,
      sendAuthCode: true,
      codefont: 0,
      submitText: '确认',
      fundMessage: '',//基金信息
      cardMessage: '',//银行卡信息
      // 支付渠道
      channelNot: [],
      dialogVisableChange: false,
      payType: '',
      bankActive: {//选择的银行卡信息
        paycentername: '',
        singledeallimit: '',
        singledaylimit: '',
      },
      isChannel: {},
      channelFlag: true
    }
  },
  created () {
    this.cardMessage = this.$route.params.cardMessage
    this.fundMessage = this.$route.params.fundMessage
    if(this.$route.params.name == "accountManagement") {//新增渠道
      this.channelNot = this.cardMessage.channelNot
      this.bankActive = this.channelNot[0]
      this.isChannel = this.bankActive
      this.payType = this.bankActive.paycentername
      this.channelid = this.bankActive.channelid
      this.paycenterid = this.bankActive.paycenterid
    } else {
      this.channelid = this.cardMessage.channelid
      this.paycenterid = this.cardMessage.paycenterid
    }
  },
  methods: {
    reback () {
      let path = this.$route.params.name
      if (path) {
        if (path == "publicBuy") {//基金购买
          this.$router.push({
            name: 'publicBuy',
            params: {
              fundMessage: this.fundMessage
            }
          })
        } else if (path == "fixedBuyOpen") {//基金定投
          this.$router.push({
            name: 'fixedBuyOpen',
            params: {
              message: this.fundMessage
            }
          })
        } else if (path == "accountManagement") {//银行卡管理
          this.$router.push({ name: 'accountManagement', params: { active: '2' } })
        } else {
          this.$router.push({ name: path })
        }
      } else {
        this.$router.push({ name: 'myAssets' })
      }
    },
    counter () {
      this.codeDisable = true
      this.sendAuthCode = false;
      this.auth_time = 90;
      var auth_timetimer = setInterval(() => {
        if (this.auth_time == 0) {
          this.sendAuthCode = true;
          this.codeDisable = false
          clearInterval(auth_timetimer);
          this.codefont = 1
        } else {
          this.auth_time--;
        }
      }, 1000);
    },
    // 获取验证码
    getCode () {
      this.phoneError = ''
      const ret = /^(13|15|16|17|18|14|19)\d{9}$/g;
      if (this.verificationForm.phone == '') {
        this.phoneError = '预留手机号不能为空'
      } else if (!ret.test(this.verificationForm.phone)) {
        this.phoneError = '请输入正确的手机号码'
      } else {
        this.$http.post(this.$apiPath.identifySend, {
          paycenterid: this.paycenterid,
          channelid: this.channelid,
          certificateno: Base64.decode(this.$commonJs.getCookie('u_id')),// 身份证
          depositacct: this.cardMessage.depositacct,// 银行卡
          depositacctname: Base64.decode(this.$commonJs.getCookie('u_name1')),// 姓名
          mobiletelno: this.verificationForm.phone,// 手机号
          sessionId: this.$commonJs.getCookie('sessionid'),
          deviceId: '',
          appnew: 1,
        }).then(res => {
          // console.log('验证码',res);
          if (res.data.code == "200") {
            this.channelFlag = false
            this.counter();
          } else {
            this.phoneError = res.data.message
          }
        }).catch(err => { })
        // 旧
        // this.$http.post(this.$apiPath.hfidentifySend, {
        //   UsrNameText: Base64.decode(this.$commonJs.getCookie('u_name1')),//用户姓名
        //   CertId: Base64.decode(this.$commonJs.getCookie('u_id')),//证件号 
        //   channelid: this.channelid,//
        //   CardNo: this.cardMessage.depositacct,//卡号
        //   BankMP: this.verificationForm.phone,//手机号
        //   BankProvinceCode: '0011',//省份代码，暂时传0011 
        //   BankRegionCode: '1100',//省份代码，暂时传1100 
        // }).then(res => {
        //   // console.log(res);
        //   if (res.data.code == "200") {
        //     this.counter();
        //   } else {
        //     this.phoneError = res.data.message
        //   }
        // }).catch(err => { })
      }
    },
    submit () {
      this.codeError = ''
      this.$refs.verificationFormRef.validate(valid => {
        if (!valid || this.sendAuthCode) return
        this.submitText = '确认中...'
        this.$http.post(this.$apiPath.verifySend, {
          paycenterid: this.paycenterid,
          channelid: this.channelid,
          certificateno: Base64.decode(this.$commonJs.getCookie('u_id')),// 身份证
          depositacct: this.cardMessage.depositacct,// 卡号
          depositacctname: Base64.decode(this.$commonJs.getCookie('u_name1')),// 姓名
          mobiletelno: this.verificationForm.phone,// 手机号
          authcode: this.verificationForm.code,// 短信验证码
          sessionId: this.$commonJs.getCookie('sessionid'),
          deviceId: '',
          appnew: 1,
        }).then(res => {
          // console.log('结果', res);
          if (res.data.code == "200") {
            if(this.$route.params.name == "accountManagement") {//
              this.addChannel()
            } else {
              this.$message.success('成功')
              this.reback()
            }
          } else {
            this.codeError = res.data.message
            this.submitText = '确认'
          }
        }).catch(err => { })
        // 旧
        // this.$http.post(this.$apiPath.hfverifySend, {
        //   UsrNameText: Base64.decode(this.$commonJs.getCookie('u_name1')),//用户姓名
        //   CertId: Base64.decode(this.$commonJs.getCookie('u_id')),//证件号
        //   CardNo: this.cardMessage.depositacct,//卡号
        //   BankMP: this.verificationForm.phone,//手机号 
        //   AuthCode: this.verificationForm.code,//验证码，测试传111111
        // }).then(res => {
        //   // console.log('结果', res);
        //   if (res.data.code == "200") {
        //     this.$message.success('成功')
        //     this.reback()
        //   } else {
        //     this.codeError = res.data.message
        //     this.submitText = '确认'
        //   }
        // }).catch(err => { })
      })
    },
    //添加新渠道
    addChannel() {
      this.codeError = ''
      this.$http.post(this.$apiPath.addChannel, {
        paycenterid: this.paycenterid,
        moneyaccount: this.cardMessage.moneyaccount,
        channelid: this.channelid,
        sessionId: this.$commonJs.getCookie('sessionid'),
        deviceId: '',
        appnew: 1
      }).then(res => {
        // console.log('添加新渠道',res);
        if (res.data.code == "200") {
            this.$message.success('成功')
            this.reback()
          } else {
            this.codeError = res.data.message
            this.submitText = '确认'
          }
      }).catch(err => { })
    },
    // 支付渠道
    channelCancel() {
      this.payType = this.bankActive.paycentername
      this.dialogVisableChange = false
    },
    channelSure() {
      this.dialogVisableChange = false
      this.bankActive = this.isChannel
    },
    bankChange(val) {
      this.isChannel = this.channelNot.find(item => item.paycentername == val)
    },
    replace() {
      if(this.channelFlag) {
        this.dialogVisableChange = true
      } else {
        this.$message.warning('已获取验证码，不可更改支付渠道')
      }
    }
  }
}
</script>
